import { UserRegistrationFlow } from "./user-registration-flow";
import type { RegisterUserType } from "@/domain/core";

// ============================================================================
// USER REGISTRATION HANDLER TYPES
// ============================================================================

interface UserRegistrationHandlerProps {
  children: React.ReactNode;
  onRegistrationComplete?: (userType?: RegisterUserType) => void;
}

// ============================================================================
// USER REGISTRATION HANDLER COMPONENT
// ============================================================================

export function UserRegistrationHandler({
  children,
  onRegistrationComplete
}: UserRegistrationHandlerProps) {
  return (
    <UserRegistrationFlow
      onRegistrationComplete={onRegistrationComplete}
      showRegistrationWizard={true}
    >
      {children}
    </UserRegistrationFlow>
  );
}
